var _a;
export var uV = {
    name: 'uV',
    min: -500,
    max: 1500,
    deltaMain: 500,
    deltaSecondary: 100,
};
export var mV = {
    name: 'mV',
    min: -0.5,
    max: 1.5,
    deltaMain: 0.5,
    deltaSecondary: 0.1,
};
export var mmHg = {
    name: 'mmHg',
    min: 0,
    max: 200,
    deltaMain: 100,
    deltaSecondary: 20,
};
export var def = {
    min: -500,
    max: 1500,
    deltaMain: 500,
    deltaSecondary: 100,
};
//SOP:
export var SOP_CLASS_UIDS = {
    Sop12LeadECGWaveformStorage: '1.2.840.10008.5.1.4.1.1.9.1.1',
    GeneralECGWaveformStorage: '1.2.840.10008.5.1.4.1.1.9.1.2',
    AmbulatoryECGWaveformStorage: '1.2.840.10008.5.1.4.1.1.9.1.3',
    HemodynamicWaveformStorage: '1.2.840.10008.5.1.4.1.1.9.2.1', //YES
};
export var ECG_DISPLAY_OPTIONS;
(function (ECG_DISPLAY_OPTIONS) {
    ECG_DISPLAY_OPTIONS["2x5"] = "2x5";
    ECG_DISPLAY_OPTIONS["4x2.5r"] = "4x2.5r";
})(ECG_DISPLAY_OPTIONS || (ECG_DISPLAY_OPTIONS = {}));
export var ECG_CHANNELS;
(function (ECG_CHANNELS) {
    ECG_CHANNELS["I"] = "I";
    ECG_CHANNELS["II"] = "II";
    ECG_CHANNELS["III"] = "III";
    ECG_CHANNELS["aVR"] = "aVR";
    ECG_CHANNELS["aVL"] = "aVL";
    ECG_CHANNELS["aVF"] = "aVF";
    ECG_CHANNELS["V1"] = "V1";
    ECG_CHANNELS["V2"] = "V2";
    ECG_CHANNELS["V3"] = "V3";
    ECG_CHANNELS["V4"] = "V4";
    ECG_CHANNELS["V5"] = "V5";
    ECG_CHANNELS["V6"] = "V6";
    ECG_CHANNELS["V7"] = "V7";
    ECG_CHANNELS["V8"] = "V8";
    ECG_CHANNELS["V9"] = "V9";
})(ECG_CHANNELS || (ECG_CHANNELS = {}));
// start time in seconds
export var ECG_START_TIME_POINT_CHANNELS = (_a = {},
    _a[ECG_CHANNELS.I] = 0,
    _a[ECG_CHANNELS.aVR] = 2.5,
    _a[ECG_CHANNELS.V1] = 5,
    _a[ECG_CHANNELS.V4] = 7.5,
    _a[ECG_CHANNELS.II] = 0,
    _a[ECG_CHANNELS.aVL] = 2.5,
    _a[ECG_CHANNELS.V2] = 5,
    _a[ECG_CHANNELS.V5] = 7.5,
    _a[ECG_CHANNELS.III] = 0,
    _a[ECG_CHANNELS.aVF] = 2.5,
    _a[ECG_CHANNELS.V3] = 5,
    _a[ECG_CHANNELS.V6] = 7.5,
    _a);
export var CHANNEL_DEFINITION_START_TAG = 'xfffee000';
export var CANVAS_ID = 'ecgView';
export var TABLE_ID = 'divTableBody';
export var TOOLBAR_ID = 'toolsECG';
export var BUTTON_AMPLITUDE_UP_ID = 'amplitudeUp';
export var BUTTON_AMPLITUDE_DOWN_ID = 'amplitudeDown';
export var BUTTON_TIME_LEFT_ID = 'timeLeft';
export var BUTTON_TIME_RIGHT_ID = 'timeRight';
export var BUTTON_PLUS_ID = 'plus';
export var BUTTON_MINUS_ID = 'minus';
export var TEXT_TIME_ID = 'textTime';
export * from './dicomTags';
//# sourceMappingURL=index.js.map